import { render, staticRenderFns } from "./AccessRules.vue?vue&type=template&id=18e21f05&"
import script from "./AccessRules.vue?vue&type=script&lang=js&"
export * from "./AccessRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports